import { createSlice } from "@reduxjs/toolkit";

const initialHashtagsState = {
  hashtagsList: [],
  listLoading: false,
  error: null,
  hashtagsDetailsList: [],
  listDetailsLoading: false,
  hashtagBanned: null,
  banLoading: false,
};

export const callTypes = {
  list: "list",
  listDetails: "listDetails",
  ban: "ban",
};

export const hashtagsSlice = createSlice({
  name: "Hastags",
  initialState: initialHashtagsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.payload.error}`;
      switch (action.payload.callType) {
        case callTypes.list:
          state.listLoading = false;
          break;
        case callTypes.listDetails:
          state.listDetailsLoading = false;
          break;
        case callTypes.ban:
          state.banLoading = false;
          break;
        default:
          break;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      switch (action.payload.callType) {
        case callTypes.list:
          state.listLoading = true;
          break;
        case callTypes.listDetails:
          state.listDetailsLoading = true;
          break;
        case callTypes.ban:
          state.banLoading = true;
          break;
        default:
          break;
      }
    },
    hashtagsFetched: (state, action) => {
      state.hashtagsList = action.payload.hashtagsList;
      state.listLoading = false;
      state.error = null;
    },
    hashtagDetailsFetched: (state, action) => {
      state.hashtagsDetailsList = action.payload.hashtagsPostsDetails;
      state.listDetailsLoading = false;
      state.error = null;
    },
    hashtagBanned: (state, action) => {
      state.hashtagBanned = action.payload.hashtagBanned;
      state.banLoading = false;
      state.error = null;
    },
  },
});
